module.exports = __webpack_public_path__ + "static/media/floral-preview.65cef146.png";